/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OutdoorInputs */

const en_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdoor Thailand`)
};

const th_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลางแจ้งประเทศไทย`)
};

const ja_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屋外`)
};

const fr_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extérieur Thaïlande`)
};

const es_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exterior Tailandia`)
};

const ru_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На улице`)
};

const zh_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`户外`)
};

const vi_outdoor = /** @type {(inputs: OutdoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngoài trời Thái Lan`)
};

/**
* | output |
* | --- |
* | "Outdoor Thailand" |
*
* @param {OutdoorInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const outdoor = /** @type {((inputs?: OutdoorInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OutdoorInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_outdoor(inputs)
	if (locale === "ja") return ja_outdoor(inputs)
	if (locale === "fr") return fr_outdoor(inputs)
	if (locale === "es") return es_outdoor(inputs)
	if (locale === "ru") return ru_outdoor(inputs)
	if (locale === "zh") return zh_outdoor(inputs)
	if (locale === "vi") return vi_outdoor(inputs)
	return en_outdoor(inputs)
});